<div class="calendar-container" [class.disabled]="isLoading">
  <div class="calendar-header">
    <div class="calendar-date-control">
      <div class="btn-area">
        <div class="button" (click)="moveToPreviousMonth($event)" style="color: black">
          <div class="btn-inner dense" style="margin: 2px 6px;"><i class="material-icons">keyboard_arrow_left</i></div>
        </div>
      </div>
      <div class="date">
        <div class="month" #monthSelectDropdown (click)="toggleMonthOptions($event)">
          <ng-container *ngIf="currentMonth">{{ currentMonth | date: 'MMMM' }}</ng-container>
          <div class="select-list" *ngIf="isUnfoldMonthSelectDropdown" style="width: 80px">
            <div class="select-result has-child" *ngFor="let month of monthOptions" [class.disabled]="selectedMonth === month" (click)="selectMonth($event, month)">
              <div class="date-dropdown-list" [class.selected]="selectedMonth === month">{{ month.label }}</div>
            </div>
          </div>
        </div>
        <div class="year" #yearSelectDropdown (click)="toggleYearOptions($event)">
          <ng-container *ngIf="currentMonth">{{ currentMonth | date: 'y' }}</ng-container>
          <div class="select-list" *ngIf="isUnfoldYearSelectDropdown" style="width: 80px">
            <div class="select-result" *ngFor="let year of yearOptions" [class.disabled]="selectedYear === year" (click)="selectYear($event, year)">
              <div class="date-dropdown-list" [class.selected]="selectedYear === year">{{ year }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-area">
        <div class="button" (click)="moveToNextMonth($event)" style="color: black">
          <div class="btn-inner dense" style="margin: 2px 6px;"><i class="material-icons">keyboard_arrow_right</i></div>
        </div>
      </div>
    </div>
    <div class="v-center" style="flex: 1; justify-content: space-between;">
      <div class="btn-area">
        <div class="button button-white" (click)="selectToday($event)" style="box-shadow: none">
          <div class="btn-inner">Today</div>
        </div>
      </div>
      <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'left-center')" style="display: flex; align-items: center; margin-left: -10px">
        <comp-icon class="--g-tooltip-icon" [icon]="'info'" [size]="16" [color]="'#55647B'"></comp-icon>
        <div class="--g-tooltip" style="text-transform: none">
          <div>- Logs are retained for only 1 year.</div>
          <div>- <span style="color: #30A14E; font-weight: bold">Green highlight</span>: Indicates the presence of Video Event, Playback, or Timelapse events. </div>
          <div>- The color is based on the number of events and does not reflect any filters applied. It shows the total count of all events that occurred on that date.</div>
        </div>
      </div>
    </div>
  </div>
  <div class="weekdays">
    <div class="weekday" *ngFor="let day of weekdays">{{ day }}</div>
  </div>
  <div class="calendar-grid" *ngIf="!isLoading">
    <ng-container *ngFor="let date of dates">
      <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin-left: 0">
        <div class="date-cell" (click)="selectDate(date, $event)" [class.disabled]="!date.day || date.disabled" [ngClass]="date.highlightColorByEvent" [class.selected]="date.isSelected">{{ date.day }}</div>
        <div class="--g-tooltip tooltip-background" style="text-transform: none">{{date.eventNumber || 0}} events</div>
      </div>
    </ng-container>
  </div>
  <div class="calendar-event-color-container">
    <div>Less</div>
    <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin-left: 0">
      <div class="calendar-event-color normal"></div>
      <div class="--g-tooltip tooltip-background" style="text-transform: none">0 events</div>
    </div>
    <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin-left: 0">
      <div class="calendar-event-color event-low"></div>
      <div class="--g-tooltip tooltip-background" style="text-transform: none">1 - 50 events</div>
    </div>
    <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin-left: 0">
      <div class="calendar-event-color event-middle"></div>
      <div class="--g-tooltip tooltip-background" style="text-transform: none">51 - 100 events</div>
    </div>
    <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin-left: 0">
      <div class="calendar-event-color event-high"></div>
      <div class="--g-tooltip tooltip-background" style="text-transform: none">More than 100 events</div>
    </div>
    <div>More</div>
  </div>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
</div>